import { render } from "./BlogStyleSeries.vue?vue&type=template&id=4a4798f0&scoped=true"
import script from "./BlogStyleSeries.vue?vue&type=script&lang=js"
export * from "./BlogStyleSeries.vue?vue&type=script&lang=js"

import "./BlogStyleSeries.vue?vue&type=style&index=0&id=4a4798f0&lang=scss&scoped=true"

import exportComponent from "/Users/chris.bamford/Documents/GitHub/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a4798f0"]])

export default __exports__